export function capitalize(word = '') {
	return (word[0] || '').toUpperCase() + word.substr(1);
}
